export function getScreenSize(): string | null {
	let screenSize: string | null = null; // Reset the cache on screen resize
	const width: number = window.innerWidth;
	if (width >= 320 && width <= 669) {
		screenSize = 'mobile';
	} else if (width >= 670 && width <= 1019) {
		screenSize = 'tablet';
	} else {
		screenSize = 'desktop';
	}
	return screenSize;
}
